import script from "./internationalization.vue?vue&type=script&setup=true&lang=js"
export * from "./internationalization.vue?vue&type=script&setup=true&lang=js"

import "./internationalization.vue?vue&type=style&index=0&id=b774b48e&scoped=true&lang=css"

import exportComponent from "D:\\D盘\\桌面\\项目\\王者荣耀后台管理系统\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b774b48e"]])

export default __exports__